import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {YzLoadingMaskComponent} from './yz-loading-mask/yz-loading-mask.component';
import {YzLoadingMoreComponent} from './yz-loading-more/yz-loading-more.component';
import {SharedModule} from "../shared.module";


const COMPONENTS = [
  YzLoadingMaskComponent,
  YzLoadingMoreComponent
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS],
  imports: [SharedModule],
  exports: [...COMPONENTS]
})
export class LoadingModule {
}
